module.exports = __webpack_public_path__ + "static/media/yoga-banner.d1797c74.png";